import { BookingCategoryType } from '@com-delta-idp/mnx-sitewide-header-ui';
import { Dates } from '@com-delta-idp/mnx-sitewide-shared-core-smart';

export const BOOKING_CATEGORY_TYPE: Record<string, BookingCategoryType> = {
  flights: 'flights',
  stays: 'stays',
  cars: 'cars',
  vacations: 'vacations',
  cruises: 'cruises'
};

export interface AlternateFlow {
  enabled?: boolean;
  label?: string;
  link?: string;
  redirectback?: boolean;
}

export interface TripData {
  confirmationNo: string;
  firstName: string;
  lastName: string;
  returnAction: string;
  originalSource: string;
  interstitial: boolean;
}

export interface NextgenReshopHeader {
  headerIcon: string;
  headerlabel: string;
  id: string;
}

export interface DarkSiteConfig {
  level: string;
  theme: string;
  blackThemeLogo: string;
  logo: string;
}

export interface SlimNavUpdate {
  dates?: Dates;
  origin?: string;
  destination?: string;
}
